import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'; 
import FetrapiEnums from "../../enum/enums";

@Component({
  selector: 'modal-alert',
  templateUrl: './modal-alert.component.html',
  styleUrls: ['./modal-alert.component.scss']
})
export class ModalAlertComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }
  public modalMessage: string = '';
  public headerTitle: FetrapiEnums.ModalType = FetrapiEnums.ModalType.Info;

  ngOnInit() { 

  }

  showModal(message: string, modalType: FetrapiEnums.ModalType = FetrapiEnums.ModalType.Info) { 
    this.modalMessage = message;
    this.headerTitle = modalType;
  } 

}
